"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = exports.other = exports.listWithOtherConfig = exports.ListWithOtherDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _selectConfig = require("../../fields/Select/selectConfig");

var _textfieldConfig = require("../../fields/Textfield/textfieldConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _selectConfig.SelectDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var FieldUiDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldUiDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var select = {
  key: 'option',
  type: 'select',
  items: [],
  validation: []
};
exports.select = select;
var other = {
  key: 'other',
  maxLength: 100,
  label: 'Other...',
  type: 'text',
  validation: [{
    required: true
  }]
};
exports.other = other;
var listWithOtherConfig = {
  type: 'listWithOther',
  // Not including 'other' field here, as backend validation will apply whether the field is visible or not.
  // By not including, backend validation is disabled for the 'other' field.
  fields: [select]
};
exports.listWithOtherConfig = listWithOtherConfig;

var ListWithOtherDefinition = _flowRuntime["default"].type("ListWithOtherDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("items", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("listType", _flowRuntime["default"].union(_flowRuntime["default"].string("radio"), _flowRuntime["default"].string("checkbox"), _flowRuntime["default"].string("select"))))), _flowRuntime["default"].property("ui", _flowRuntime["default"].ref(FieldUiDefinition)), _flowRuntime["default"].property("type", _flowRuntime["default"].string("listWithOther")))));

exports.ListWithOtherDefinition = ListWithOtherDefinition;